export default __webpack_public_path__ + "static/media/bring-front.cd4628a9.svg";